import jwt_decode from "jwt-decode";

/** School name / address / logo from the login token (same source as PdfHeader) */
export const schoolFromToken = () => {
  try {
    const u = jwt_decode(sessionStorage.getItem("token"));
    const addr = [u.companystreet, [u.companystate, u.companypincode].filter(Boolean).join("-")].filter(Boolean).join(", ");
    return { name: u.companyname, address: addr, logo: u.tenantcode ? `/${u.tenantcode}-sidebar-logo.png` : null };
  } catch (e) {
    return {};
  }
};
